/**
 * Central icon set (lucide-react) — replaces emoji with a consistent,
 * professional iconography across the compliance screens.
 */
import {
  Building2,
  User,
  Fingerprint,
  CreditCard,
  ShieldAlert,
  MapPin,
  Landmark,
  type LucideIcon,
} from 'lucide-react';
import type { Persona } from '../lib/phase1';

export function PersonaIcon({
  persona,
  className,
}: {
  persona: Persona;
  className?: string;
}) {
  const I = persona === 'legal' ? Building2 : User;
  return <I className={className} strokeWidth={1.75} />;
}

/** Validation key → icon (matches lib/phase1 validation keys). */
const VAL_ICON: Record<string, LucideIcon> = {
  svi: Fingerprint,
  apc: CreditCard,
  scr: ShieldAlert,
  dom: MapPin,
  reg: Landmark,
};

/** Always returns a concrete icon component (fallback for unknown keys). */
export function valIcon(key: string): LucideIcon {
  return VAL_ICON[key] ?? ShieldAlert;
}
